import clsx from 'clsx';
import type { JSX } from 'react';
import { FormField } from '@/components/form';
import type { UnitFormErrors, UnitFormState } from './unitFormState';

interface UnitExtrasSectionProps {
  formState: UnitFormState;
  errors: UnitFormErrors;
  disabled: boolean;
  isUploadingHero: boolean;
  setFormState: React.Dispatch<React.SetStateAction<UnitFormState>>;
  clearFieldError: (field: keyof UnitFormState) => void;
}

const inputClass =
  'rounded-2xl border border-surface-subtle px-4 py-2.5 text-base text-text-primary shadow-sm transition focus:border-brand-primary focus:outline-none focus:ring-2 focus:ring-brand-primary/30 disabled:cursor-not-allowed disabled:opacity-60 md:py-2 md:text-sm';

export function UnitExtrasSection({
  formState,
  errors,
  disabled,
  isUploadingHero,
  setFormState,
  clearFieldError,
}: UnitExtrasSectionProps): JSX.Element {
  return (
    <>
      <FormField
        id="unit-divisible-toggle"
        label="Divisible"
        description="Shows the Divisible label on public listings."
        error={errors.potentiallyDivisible}
      >
        <label className="flex items-center gap-3 text-sm font-medium text-text-primary">
          <input
            type="checkbox"
            checked={formState.potentiallyDivisible}
            onChange={(event) => {
              setFormState((prev) => ({ ...prev, potentiallyDivisible: event.target.checked }));
              clearFieldError('potentiallyDivisible');
            }}
            disabled={disabled || isUploadingHero}
            className="h-4 w-4 rounded border-surface-subtle text-brand-primary focus:ring-brand-primary"
          />
          {formState.potentiallyDivisible ? 'Yes' : 'No'}
        </label>
      </FormField>

      <FormField
        id="unit-incentives"
        label="Incentives"
        error={errors.incentives}
        description="If filled, public listings show an Incentives label and filter. Example: One month free."
      >
        <textarea
          rows={3}
          value={formState.incentives}
          onChange={(event) => {
            setFormState((prev) => ({ ...prev, incentives: event.target.value }));
            clearFieldError('incentives');
          }}
          disabled={disabled || isUploadingHero}
          className={clsx(inputClass, 'min-h-[96px]')}
        />
      </FormField>
    </>
  );
}
